var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 317.855,
    height: 179.253,
    viewBox: "0 0 317.855 179.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M211.9,35.33V148.984M281.2,7.09V177.224M73.3,148.984V35.33M4,177.224V7.09",
    transform: "translate(16.325 1.469)",
    fill: "none",
    stroke: "#f5f8fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M3,7H5.945A178.438,178.438,0,0,1,158.912,93.6l.016.026A179.49,179.49,0,0,0,311.91,180.253h2.945",
    transform: "translate(0)",
    fill: "none",
    stroke: "#f5f8fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M3,180.253H5.945a178.438,178.438,0,0,0,152.967-86.6l.016-.026A178.451,178.451,0,0,1,311.91,7h2.945",
    transform: "translate(0)",
    fill: "none",
    stroke: "#f5f8fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.58f7fc5c42e725a92fb5845b93527984.svg";
export { ForwardRef as ReactComponent };